export const parseEstimationString = (value: string, type?: 'manual') =>
  type === 'manual' ? (([hours, minutes]) => hours * 60 + minutes)(value.split(':', 2).map(Number)) * 60 : 0;
export const parseEstimationValue = (value: number) => (value ? value / 60 : 0);
